<template>
   <div href="#" class="list-group-item list-group-item-action flex-column align-items-start transition-card">
    <div class="d-flex w-100 justify-content-between">
      <h5 class="mb-1">{{object.title}}</h5>
      <small class="text-muted">{{ object.date }}</small>
    </div>
    <p class="mb-1">{{object.comments}}</p>
    <span style="color: gold; font-size: 1.2rem;">★★★★★</span>
    <div><small class="text-muted">{{ object.author }}</small></div>
  </div>

</template>

<script>


export default {
  props: ['object'],
    //title: String,
    //subtitle: String,
    //text: String,
  
  methods: {}
};
</script>


<style scoped>
.transition-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  /*  //border-left: 5px solid #198754;Bootstrap green */
}

.transition-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  background-color: lightgrey; /* #f9fdfb;  light green tint on hover */
  color: black; /* #f9fdfb;  light green tint on hover */
  cursor: default;
}


</style>